module.exports = __webpack_public_path__ + "img/logo.0fb9822f.png";